export default __webpack_public_path__ + "static/media/what-we-offers-04.cf186e61.jpg";